import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "../../lib/api";
import { useLang } from "../../context/LanguageContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../components/ui/select";
import { toast } from "sonner";

const ROLES = ["client", "owner", "referral", "agent", "admin"];

export function UsersManager() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); const { data } = await api.get("/admin/users"); setItems(data.items); setLoading(false); };
  useEffect(() => { load(); }, []);

  const setRole = async (id, role) => { await api.patch(`/admin/users/${id}`, { role }); toast.success("Role updated"); load(); };

  if (loading) return <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-primary" size={28} /></div>;

  return (
    <div>
      <h1 className="font-serif text-4xl font-light mb-2">{t("dash.users")}</h1>
      <p className="text-muted-foreground font-light mb-8">{items.length} accounts</p>

      <div className="border border-border overflow-x-auto">
        <table className="w-full text-sm" data-testid="users-table">
          <thead>
            <tr className="border-b border-border text-left label-caps text-muted-foreground text-[0.6rem]">
              <th className="p-4">Name</th><th className="p-4">Email</th>
              <th className="p-4 hidden md:table-cell">Phone</th><th className="p-4">Role</th>
            </tr>
          </thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} className="border-b border-border last:border-0 hover:bg-secondary/40" data-testid={`user-row-${u.id}`}>
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <span className="w-9 h-9 rounded-full bg-primary/15 text-primary grid place-items-center text-xs font-medium">{u.name?.[0]}</span>
                    {u.name}
                  </div>
                </td>
                <td className="p-4 text-muted-foreground">{u.email}</td>
                <td className="p-4 hidden md:table-cell text-muted-foreground">{u.phone || "—"}</td>
                <td className="p-4">
                  <Select value={u.role} onValueChange={(v) => setRole(u.id, v)}>
                    <SelectTrigger className="w-36 rounded-none h-9 text-xs capitalize" data-testid={`user-role-${u.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{ROLES.map((r) => <SelectItem key={r} value={r} className="capitalize">{r}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
